import React, { useMemo } from "react";
import { useFirestoreCollection } from "../../../lib/useFirestore.js";
import { Crumbs, Back } from "./nav.jsx";

/**
 * Screen 2 — "What are you making?" Two doors:
 *   Capture Sheet  (v1, active) → the groups screen
 *   Model Previews (v2, later)  → disabled this slice, routes nowhere
 *
 * Each door shows readiness derived from the captureSheet subcollection. The
 * Capture Sheet door's chip reports thumbnail-upload progress (the bridge's
 * "preview" module duty); Model Previews is a placeholder until v2.
 */
export default function JobHome({ nav, go }) {
  const { jobId, jobLabel } = nav;
  const { data: groups } = useFirestoreCollection(jobId ? `jobs/${jobId}/captureSheet` : null);

  const { captureCount, thumbsUploaded, allThumbs } = useMemo(() => {
    const cc = groups.reduce((n, g) => n + (g.captureCount || 0), 0);
    const tu = groups.reduce((n, g) => n + (g.thumbsUploaded || 0), 0);
    return { captureCount: cc, thumbsUploaded: tu, allThumbs: cc > 0 && tu >= cc };
  }, [groups]);

  const csChip = captureCount === 0
    ? { cls: "gray", text: "no captures yet" }
    : allThumbs
      ? { cls: "blue", text: `thumbnails ready · ${captureCount} captures` }
      : { cls: "amber", text: `thumbnails ${thumbsUploaded}/${captureCount}` };

  return (
    <>
      <Crumbs trail={[{ label: "Sheets", screen: "home", patch: { jobId: null } }, { label: jobLabel }]} go={go} />
      <Back label="All jobs" onClick={() => go("home", { jobId: null, groupId: null })} />
      <div className="qhead">What are you making?</div>

      <button type="button" className="door" onClick={() => go("groups")}>
        <span className="ico" style={{ background: "#D9770614", color: "var(--s-capture)" }}>▦</span>
        <span>
          <b>Capture Sheet</b> — photos from the rig <span className="chip blue" style={{ marginLeft: 4 }}>v1</span>
          <span className="dd">Pick 6 cameras per capture · contact-sheet PDF · send to the job</span>
          <span className="ready"><span className={`chip ${csChip.cls}`}>{csChip.text}</span></span>
        </span>
      </button>

      <div className="door disabled" aria-disabled="true" title="Model Previews land in v2">
        <span className="ico" style={{ background: "#8B5CF614", color: "var(--s-purple)" }}>◆</span>
        <span>
          <b>Model Previews</b> — renders + client selects <span className="chip purple" style={{ marginLeft: 4 }}>v2 · later</span>
          <span className="dd">Blender renders per capture · preview-sheet PDF with checkboxes</span>
          <span className="ready"><span className="chip gray">not in this build</span></span>
        </span>
      </div>

      {Array.isArray(nav.sheetFiles) && nav.sheetFiles.length > 0 && (
        <div className="card filesbox">In this job's files<br />
          {nav.sheetFiles.map((f) => <span key={f.name}><span className="fname">{f.name}</span> · {f.date}</span>)}
        </div>
      )}
    </>
  );
}
